<template>
  <div class="login-container">
    <div class="login-form">
      <h1 class="logo"><em>Data</em>poort</h1>
      <p v-if="passwordReset">
        Je wachtwoord is veranderd, je kan nu inloggen met je nieuwe wachtwoord.
        <router-link class="btn btn-primary" :to="{ name: 'login' }">Inloggen</router-link>
      </p>
      <p v-else-if="error">
        Er is een fout opgetreden tijdens het aanvragen van een nieuw wachtwoord, neem contact op
        met jan@jan.tm.
      </p>
      <form @submit="resetPassword($event)" v-else>
        <input
          placeholder="Wachtwoord"
          v-model="password"
          type="password"
          autocomplete="password"
        />
        <input
          placeholder="Bevestig wachtwoord"
          v-model="passwordConfirmation"
          type="password"
          autocomplete="password"
        />
        <input type="submit" value="Verstuur" class="btn btn-primary" :disabled="loading" />
        <router-link class="btn btn-secondary" :to="{ name: 'login' }">Inloggen</router-link>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue'
import axios from 'axios'

const props = defineProps({
  token: {
    type: String,
    required: true,
  },
})

const token = toRef(props, 'token')
const password = ref('')
const passwordConfirmation = ref('')
const error = ref(false)
const loading = ref(false)
const passwordReset = ref(false)

const resetPassword = (event: Event) => {
  loading.value = true
  event.preventDefault()
  axios
    .post('/api/reset_password', {
      token: token.value,
      password: password.value,
      password_confirmation: passwordConfirmation.value,
    })
    .then(
      () => {
        passwordReset.value = true
        loading.value = false
      },
      () => {
        error.value = true
      },
    )
  return false
}
</script>
